import styled from 'styled-components'

export const ProductNameUl = styled.ul`
  padding-left: ${props => props.theme.spacing.sp24};
  margin: 0;
`
